[
  {
    "id": "cargo",
    "name": {
      "en": "Cargo ship",
      "de": "Frachtschiff"
    },
    "lengthM": 180,
    "lengthClass": "ge50",
    "hull": "cargo"
  },
  {
    "id": "coaster",
    "name": {
      "en": "Coaster",
      "de": "Küstenmotorschiff"
    },
    "lengthM": 85,
    "lengthClass": "ge50",
    "hull": "cargo"
  },
  {
    "id": "sailing-yacht",
    "name": {
      "en": "Sailing yacht",
      "de": "Segelyacht"
    },
    "lengthM": 14,
    "lengthClass": "m12to20",
    "hull": "sailing"
  },
  {
    "id": "sailing-dinghy",
    "name": {
      "en": "Small sailing boat",
      "de": "Kleines Segelboot"
    },
    "lengthM": 5,
    "lengthClass": "lt7",
    "hull": "sailing"
  },
  {
    "id": "trawler",
    "name": {
      "en": "Trawler",
      "de": "Fischkutter"
    },
    "lengthM": 26,
    "lengthClass": "m20to50",
    "hull": "trawler"
  },
  {
    "id": "trawler-large",
    "name": {
      "en": "Large trawler",
      "de": "Großer Trawler"
    },
    "lengthM": 62,
    "lengthClass": "ge50",
    "hull": "trawler"
  },
  {
    "id": "tug",
    "name": {
      "en": "Tug",
      "de": "Schlepper"
    },
    "lengthM": 32,
    "lengthClass": "m20to50",
    "hull": "tug"
  },
  {
    "id": "workboat",
    "name": {
      "en": "Work vessel",
      "de": "Arbeitsschiff"
    },
    "lengthM": 48,
    "lengthClass": "m20to50",
    "hull": "tug"
  },
  {
    "id": "pilot-vessel",
    "name": {
      "en": "Pilot vessel",
      "de": "Lotsenfahrzeug"
    },
    "lengthM": 18,
    "lengthClass": "m12to20",
    "hull": "pilot"
  },
  {
    "id": "motorboat",
    "name": {
      "en": "Motorboat",
      "de": "Motorboot"
    },
    "lengthM": 9,
    "lengthClass": "m7to12",
    "hull": "small"
  },
  {
    "id": "dinghy",
    "name": {
      "en": "Dinghy",
      "de": "Beiboot"
    },
    "lengthM": 4,
    "lengthClass": "lt7",
    "hull": "small"
  },
  {
    "id": "barge",
    "name": {
      "en": "Barge under tow",
      "de": "Geschlepptes Fahrzeug"
    },
    "lengthM": 70,
    "lengthClass": "ge50",
    "hull": "barge"
  },
  {
    "id": "seaplane",
    "name": {
      "en": "Seaplane",
      "de": "Wasserflugzeug"
    },
    "lengthM": 16,
    "lengthClass": "m12to20",
    "hull": "seaplane"
  },
  {
    "id": "motor-vessel-30",
    "name": {
      "en": "Motor vessel",
      "de": "Motorschiff"
    },
    "lengthM": 30,
    "lengthClass": "m20to50",
    "hull": "cargo"
  },
  {
    "id": "hovercraft",
    "name": {
      "en": "Air-cushion vessel",
      "de": "Luftkissenfahrzeug"
    },
    "lengthM": 24,
    "lengthClass": "m20to50",
    "hull": "small"
  },
  {
    "id": "wig",
    "name": {
      "en": "WIG craft",
      "de": "WIG-Fahrzeug"
    },
    "lengthM": 22,
    "lengthClass": "m20to50",
    "hull": "seaplane"
  },
  {
    "id": "grossmotorschiff",
    "name": {
      "en": "Large inland motor vessel",
      "de": "Großmotorgüterschiff"
    },
    "lengthM": 135,
    "lengthClass": "ge50",
    "hull": "cargo"
  },
  {
    "id": "schubverband",
    "name": {
      "en": "Pushed convoy",
      "de": "Schubverband"
    },
    "lengthM": 185,
    "lengthClass": "ge50",
    "hull": "barge"
  },
  {
    "id": "faehre",
    "name": {
      "en": "Cable ferry",
      "de": "Gierseilfähre"
    },
    "lengthM": 38,
    "lengthClass": "m20to50",
    "hull": "barge"
  }
]
